'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withMutations = exports.updateIn = exports.deleteIn = exports.setIn = exports.getIn = exports.get = exports.getUIState = undefined;

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DONE_STEP = {
  done: true
};

var ForcedIterator = function () {
  function ForcedIterator(value) {
    (0, _classCallCheck3.default)(this, ForcedIterator);

    (0, _assign2.default)(this, {
      __source: value,
      currentPosition: -1
    });
  }

  (0, _createClass3.default)(ForcedIterator, [{
    key: 'next',
    value: function next() {
      var done = this.currentPosition === this.__source.length - 1;
      if (done) return DONE_STEP;
      this.currentPosition++;
      var value = done ? undefined : this.__source[this.currentPosition];
      return (0, _assign2.default)({}, {
        done: done,
        value: value
      });
    }
  }]);
  return ForcedIterator;
}();

// TODO: Make this truly Mutable


var Mutable = function () {
  function Mutable(state) {
    (0, _classCallCheck3.default)(this, Mutable);

    (0, _assign2.default)(this, {
      state: state
    });
  }

  (0, _createClass3.default)(Mutable, [{
    key: 'get',
    value: function get(key) {
      return __get(this.state, key);
    }
  }, {
    key: 'getIn',
    value: function getIn(searchKeyPath, notSetValue) {
      return __getIn(this.state, searchKeyPath, notSetValue);
    }
  }, {
    key: 'updateIn',
    value: function updateIn(keyPath, notSetValue, updater) {
      this.state = __updateIn(this.state, keyPath, notSetValue, updater);
    }
  }, {
    key: 'setIn',
    value: function setIn(keyPath, v) {
      this.state = __setIn(this.state, keyPath, v);
    }
  }, {
    key: 'deleteIn',
    value: function deleteIn(keyPath) {
      this.state = __deleteIn(this.state, keyPath);
    }
  }, {
    key: 'withMutations',
    value: function withMutations(fn) {
      this.state = __withMutations(this.state, fn);
    }
  }]);
  return Mutable;
}();

var isArrayLike = function isArrayLike(value) {
  return value && typeof value.length === 'number';
};

var forceIterator = function forceIterator(keyPath) {
  if (!isArrayLike(keyPath)) {
    throw new TypeError('Expected iterable or array-like: ' + keyPath);
  }

  return new ForcedIterator(keyPath);
};

var updateInDeepMap = function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
  var isNotSet = typeof existing === 'undefined';
  var step = keyPathIter.next();
  if (step.done) {
    var existingValue = isNotSet ? notSetValue : existing;
    var newValue = updater(existingValue);
    return newValue === existingValue ? existing : newValue;
  }
  (0, _invariant2.default)(isNotSet || existing && Object(existing) === existing, 'invalid keyPath');
  var key = step.value;
  var nextExisting = isNotSet ? undefined : existing[key];
  var nextUpdated = updateInDeepMap(nextExisting, keyPathIter, notSetValue, updater);
  if (nextUpdated === nextExisting) {
    return existing;
  } else if (typeof nextUpdated === 'undefined') {
    var result = (0, _extends4.default)({}, existing);
    delete result[key];
    return result;
  } else {
    return isNotSet ? (0, _defineProperty3.default)({}, key, nextUpdated) : (0, _extends4.default)({}, existing, (0, _defineProperty3.default)({}, key, nextUpdated));
  }
};

var __get = function __get(state, key) {
  return state[key];
};

var __getIn = function __getIn(state, searchKeyPath, notSetValue) {
  var nested = state;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(searchKeyPath), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      nested = nested ? nested[key] : undefined;
      if (typeof nested === 'undefined') {
        return notSetValue;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return nested;
};

var __updateIn = function __updateIn(state, keyPath, notSetValue, updater) {
  if (!updater) {
    updater = notSetValue;
    notSetValue = undefined;
  }

  var updatedValue = updateInDeepMap(state, forceIterator(keyPath), notSetValue, updater);

  return updatedValue;
};

var __setIn = function __setIn(state, keyPath, v) {
  return __updateIn(state, keyPath, undefined, function () {
    return v;
  });
};

var __deleteIn = function __deleteIn(state, keyPath) {
  return __updateIn(state, keyPath, function () {
    return undefined;
  });
};

var __withMutations = function __withMutations(state, fn) {
  var mutable = new Mutable(state);
  fn(mutable);
  return mutable.state;
};

/**
 * getUIState inspects redux' global state store and returns the UI state node.
 *
 * This checks to see whether state is an immutable map or a POJO.
 */
var getUIState = exports.getUIState = function getUIState(state) {
  if (typeof state.get === 'function') {
    return state.get('ui');
  }
  return state.ui;
};

/**
 * get behaves similarly to Immutable.JS' Map's get function.
 *
 * This checks to see whether state is an immutable map or a POJO.
 */
var get = exports.get = function get(state, key) {
  if (typeof state.get === 'function') {
    return state.get(key);
  }

  return __get(state, key);
};

/**
 * getIn behaves similarly to Immutable.JS' Map's getIn function.
 *
 * This checks to see whether state is an immutable map or a POJO.
 */
var getIn = exports.getIn = function getIn(state, searchKeyPath, notSetValue) {
  if (typeof state.getIn === 'function') {
    return state.getIn(searchKeyPath, notSetValue);
  }

  return __getIn(state, searchKeyPath, notSetValue);
};

/**
 * setIn behaves similarly to Immutable.JS' Map's setIn function.
 *
 * This checks to see whether state is an immutable map or a POJO.
 */
var setIn = exports.setIn = function setIn(state, keyPath, v) {
  if (typeof state.setIn === 'function') {
    return state.setIn(keyPath, v);
  }

  return __setIn(state, keyPath, v);
};

/**
 * deleteIn behaves similarly to Immutable.JS' Map's deleteIn function.
 *
 * This checks to see whether state is an immutable map or a POJO.
 */
var deleteIn = exports.deleteIn = function deleteIn(state, keyPath) {
  if (typeof state.deleteIn === 'function') {
    return state.deleteIn(keyPath);
  }

  return __deleteIn(state, keyPath);
};

/**
 * updateIn behaves similarly to Immutable.JS' Map's updateIn function.
 *
 * This checks to see whether state is an immutable map or a POJO.
 */
var updateIn = exports.updateIn = function updateIn(state, keyPath, notSetValue, updater) {
  if (typeof state.updateIn === 'function') {
    return state.updateIn(keyPath, notSetValue, updater);
  }

  return __updateIn(state, keyPath, notSetValue, updater);
};

/**
 * withMutations behaves similarly to Immutable.JS' Map's withMutations function.
 *
 * This checks to see whether state is an immutable map or a POJO.
 */
var withMutations = exports.withMutations = function withMutations(state, fn) {
  if (typeof state.withMutations === 'function') {
    return state.withMutations(fn);
  }

  return __withMutations(state, fn);
};